module.exports = __webpack_public_path__ + "img/complete-registration.75f35c19.jpg";